import httpService from '@Utils/httpService';

const baseUrl = 'api/forge/inspections';

export default {
	add(inspection, masterDbIds, assetId, base64Image) {
		return httpService.post({
			url: `${baseUrl}/createInspection`,
			data: {
				assetId: assetId,
				inspection: inspection,
				linkWithMaster: true,
				masterDbIds: masterDbIds,
				img64: base64Image,
			},
		});
	}
}